<template>
<div class="chapter">
<div class="inner_page">
<div id="Front">
<div class="fig">
<p class="fig-img"><img alt="" class="image" src="images/ufig_i.jpg"/></p>
<p class="fig-caption">A magnificent view of <i>Gneisenau</i> during trials in the summer of 1938. It is easy to see why the bow required modification – even in a flat calm the turbulence around the stem and anchor is considerable.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Front.vue?3c1aa5a5